import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, take, tap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

export const ActiveAccountGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthenticationService);
  const msalBroadcastService = inject(MsalBroadcastService);

  return msalBroadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    map(() => auth.ensureActiveAccountSnapshot()),
    tap((account) => {
      if (!account) {
        auth.loginRedirect(state.url);
      }
    }),
    map((account) => !!account),
    take(1),
  );
};
